module.exports = __webpack_public_path__ + "static/media/usdt_trc_20.906e1dbc.png";